import { useLocation } from 'react-router-dom'
import {
  TooltipProvider,
} from '@/components/ui/tooltip'
import { useTranslation } from 'react-i18next'
import { NAV_ITEMS } from '@/components/nav-config'
import HelpAgentLauncherSlot from '@/components/HelpAgent/HelpAgentLauncherSlot'
import { PAGE_HEADER, PAGE_TITLE } from '@/components/layout/pageHeader'

// FS-579: Data-area subpages that render inside the shared PageLayout shell
// would otherwise inherit the section-level "Data" label from NAV_ITEMS.
// Subpages with their own identity override the label here (mirrors the
// DataSidebar item definitions).
const SUBPAGE_OVERRIDES = [
  { prefix: '/connectors', labelKey: 'nav:menu.connectors' },
] as const

export default function AppTopbar() {
  const location = useLocation()
  const { t } = useTranslation()

  const override = SUBPAGE_OVERRIDES.find(
    (o) => location.pathname === o.prefix || location.pathname.startsWith(`${o.prefix}/`),
  )
  const activePage = NAV_ITEMS.find((p) =>
    location.pathname.startsWith(p.path) ||
    (p.childPaths?.some(cp => location.pathname.startsWith(cp)) ?? false)
  )
  const label = override ? t(override.labelKey) : activePage ? t(activePage.topbarLabelKey) : ''

  return (
    <TooltipProvider delayDuration={300}>
      <header className={`${PAGE_HEADER} justify-between`}>
        {/* UI-67: the title alone. The section glyph that sat beside it
            labelled nothing the word did not already say, and Settings and
            Tag Mapping never carried one — so it read as an inconsistency
            rather than as information. The icons stay in the left rail,
            where they are the only label a collapsed item has. */}
        <div className="flex items-center">
          <span className={`${PAGE_TITLE} truncate`}>
            {label}
          </span>
        </div>
        {/* End-side action cluster. Akeera's launcher is the only occupant
            today; the header was already justify-between for it. */}
        <div className="flex items-center gap-2">
          <HelpAgentLauncherSlot />
        </div>
      </header>
    </TooltipProvider>
  )
}
